import React from "react";

import {
  EmailTable,
  EmailAnalysisText,
  EmailUl,
  EmailLi,
  DangerousTd,
  EmailExpireText
} from "../styles";
import { generateButtonHtml } from "../constants";

const ValuationSensitivityTemplate = ({ _primaryColor, secondaryColor }) => (
  <EmailTable>
    <tr>
      <EmailAnalysisText style={{ color: `#${secondaryColor}` }}>
        Analysis at your fingertips
      </EmailAnalysisText>
    </tr>
    <tr>
      <td style={{ fontSize: "14px" }}>Potential Property Valuations with</td>
    </tr>
    <tr>
      <EmailUl>
        <EmailLi>Cap Rate Shocks</EmailLi>
        <EmailLi>Budget Shocks</EmailLi>
      </EmailUl>
    </tr>
    <tr>
      <DangerousTd dangerouslySetInnerHTML={generateButtonHtml(secondaryColor)} />
    </tr>
    <tr>
      <td>
        <EmailExpireText>
          {"(This link will expire in 30 days.)"}
        </EmailExpireText>
      </td>
    </tr>
  </EmailTable>
);

export default ValuationSensitivityTemplate;
